import React from 'react';
import { Container, Navbar, Nav, NavLink } from 'react-bootstrap';
import './topnav.css';

const TopNav = () => {
    return (
        <Navbar className="navbar" expand="lg">
            <Container>
                <Navbar.Brand href="/" className="brand"><img src={require('./pasadalogo.png')} alt="LOGO" /></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <NavLink href="/" >
                            <div className="list_item mx-4">Home</div>
                        </NavLink>
                        <NavLink href="/about" >
                            <div className="list_item mx-4">About</div>
                        </NavLink>
                        <NavLink href="/products" >
                            <div className="list_item mx-4">Products</div>
                        </NavLink>
                        {/* <NavLink href="/projects" >
                            <div className="list_item mx-4">Projects</div>
                        </NavLink> */}
                        <NavLink href="/blogs" >
                            <div className="list_item mx-4">Blogs</div>
                        </NavLink>
                        <NavLink href="/contact" >
                            <div className="list_item mx-4">Contact Us</div>
                        </NavLink>
                    </Nav>
                    <Nav className="ms-3">
                        <NavLink href="https://web.pasadaph.com/">
                            <button className="btnnav btn btn-success">Log in</button>
                        </NavLink>
                    </Nav>
                </Navbar.Collapse>

            </Container>
        </Navbar>
    );
};

export default TopNav;